

  <app-loader></app-loader>
  <ng-container *ngIf="isUser">
    <router-outlet></router-outlet>
  </ng-container>

